package de.oevbs.kunde.kundenportal2.model.services.document

import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class DocumentClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * PDFs aus dem BPCRM
     *
     * Hinweis: Stand 10.04.2024 lassen sich Fake-PDF-Dokumente ohne Änderungen am UI-Code herunterladen, wenn man
     * folgendes Setup einrichtet:
     * - lokalen `bp-crm-service2` im `fake`-Profil starten und Port ggf anpassen
     * - lokaler kupo2-Service im `local`-Profil -> Port für lokalen `bp-crm-service2` in der `application.local.yaml`
     *   hinterlegen: `origin: http://localhost:8081`
     * - lokales UI starten
     *
     * Mit diesem Setup lassen sich PDF-Dokumente herunterladen - offenbar auch durchaus verschiedene! Wie das
     * genau vom `bp-crm-service2` dispatched wird, ist nicht erforscht worden.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun getDocument(documentId: String, contentRepositoryId: String, fileName: String): ClientResponse<String> =
        get("/documents/$documentId/$contentRepositoryId/$fileName")
}